import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// Services
import { getDealerPhysicalVerificationCountApi } from "@services/Teams/getDealerPhysicalVerificationCountApi";

// Constants
import { mydealerCountLabel } from "@components/Common/Constant";

const InitialCount = [
  { Type: "Total Validation Requests", value: "0" },
  { Type: "Validated", value: "0" },
  { Type: "Pending", value: "0" },
];

/**
 * MyDealerCount Component
 * Displays dealer physical verification count statistics
 * Refactored with Tailwind CSS
 * 
 * @component
 */
const MyDealerCount = () => {
  // Redux State
  const territoryList = useSelector((state) => state?.territory?.territoryDetails);

  // Local State
  const [dealerCountData, setDealerCountData] = useState(InitialCount);

  // Fetch Dealer Physical Verification Count
  useEffect(() => {
    (async () => {
      if (territoryList && territoryList.length > 0) {
        const response = await getDealerPhysicalVerificationCountApi(territoryList);
        if (response?.status === 200) {
          const updatedCount = InitialCount.map((item) => {
            if (item.Type === "Total Validation Requests") {
              return { ...item, value: response?.data[0].total_count || "0" };
            } else if (item.Type === "Validated") {
              return { ...item, value: response?.data[0].validation_count || "0" };
            } else if (item.Type === "Pending") {
              return { ...item, value: response?.data[0].pending_count || "0" };
            }
            return item;
          });
          setDealerCountData(updatedCount);
        }
      }
    })();
  }, [territoryList]);

  return (
    <div className="w-[94%] mx-2 my-2 mb-6 h-32 bg-white rounded-xl shadow-[0.056rem_0.056rem_0.241rem_rgba(20,20,20,0.07)]">
      {/* Header */}
      <div className="w-full h-[2.125rem] bg-[#3901FF] rounded-t-xl flex items-center px-5">
        <div className="text-white font-semibold text-[0.688rem] leading-8">
          My Dealer
        </div>
      </div>

      {/* Data Grid */}
      <div className="pt-3">
        <div className="grid grid-cols-3 text-center gap-2 px-2">
          {/* Numbers */}
          {dealerCountData.length !== 0 &&
            dealerCountData?.map((item, index) => (
              <div
                key={index}
                className="text-[#3901FF] font-extrabold text-[1.227rem] -mb-1"
              >
                {item.value !== null ? item.value : "0"}
              </div>
            ))}

          {/* Labels */}
          {mydealerCountLabel?.map((items, index) => (
            <div key={index}>
              <div className="text-[#3901FF] font-bold text-[0.738rem] max-[370px]:text-[0.61rem] text-center">
                {items.heading}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MyDealerCount;
